import React, { useState } from 'react';
import Android from './img/android 1.png';
import Software from './img/software 1.png';
import Web from './img/web 1.png';
import './Our_Service.css';

export default function Our_Service() {
  const [showDetails, setShowDetails] = useState(null);

  // Function to toggle card details
  const toggleDetails = (index) => {
    if (showDetails === index) {
      setShowDetails(null); // Close the details if already open
    } else {
      setShowDetails(index); // Show details for the clicked card
    }
  };

  // Card data with additional details
  const services = [
    {
      image: Web,
      title: 'Web Development',
      technologies: ['HTML5', 'CSS3', 'JavaScript', 'React', 'Bootstrap'],
      description: 'Web development crafts websites using HTML, CSS, and JavaScript, with front-end design and back-end functionality. It s vital for online presence.',
      moreDetails: 'More details about web development...',
    },
    {
      image: Software,
      title: 'Software Development',
      technologies: ['Java', 'Python', 'C'],
      description: 'Software development is the creation and maintenance of computer programs, involving coding, testing, and debugging for various applications and systems.',
      moreDetails: 'More details about software development...',
    },
    {
      image: Android,
      title: 'Android Development',
      technologies: ['Java', 'React'],
      description: 'Android development is the process of creating mobile applications for the Android operating system using programming languages like Java or Kotlin.',
      moreDetails: 'More details about Android development...',
    },
  ];

  const cardFlipStyles = {
    flipContainer: {
      perspective: '1000px',
    },
    cardInner: {
      width: '100%',
      height: '100%',
      textAlign:"center",
      transition: 'transform 0.5s',
      transformStyle: 'preserve-3d',
      transform: 'rotateY(0deg)',
    },
    cardFront: {
      
      backfaceVisibility: 'hidden',
    },
    cardBack: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      backfaceVisibility: 'hidden',
      transform: 'rotateY(180deg)',
    },
  };

  return (
    <div className="container" style={{ marginTop: 100 }}>
      <div className="row">
        {services.map((service, index) => (
          <div className="col-md-4 carddet" key={index} style={cardFlipStyles.flipContainer}>
            <div
            id='card'
              className={`card ${showDetails === index ? 'show-details' : ''}`}
              style={{
                borderRadius: 20,
                ...cardFlipStyles.cardInner,
                transform: showDetails === index ? 'rotateY(180deg)' : 'rotateY(0deg)',
              }}
              onClick={() => toggleDetails(index)}
            >
              <div className="card-front" style={cardFlipStyles.cardFront}>
                <img src={service.image} style={{ padding: 20 }} className="card-img-top" alt={`Service ${index + 1}`} />
                <div className="card-body">
                  <h5 className="card-title" >{service.title}</h5>
                
                </div>
              </div>
              <div className="card-back" style={cardFlipStyles.cardBack }>
                <div className="card-body">
                
                  <p style={{fontSize:12,marginTop:35}}>{service.description}</p>
                  
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
